<script>
export default {
  name: 'ExternalPagesActions',
  methods: {
    openTermsAndConditions() {
      window.open('https://www.riseup.co.il/termsofuse', '_blank');
    },
    openPrivacyPolicy() {
      window.open('https://www.riseup.co.il/privacy-policy', '_blank');
    },
    sendMailTo(mailAddress) {
      window.open(`mailto:${mailAddress}`, '_blank');
    },
  },
};
</script>
